import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import image1 from '../images/kitchen.jpg';
import image2 from '../images/kitchen2.jpg';
import image3 from '../images/kitchen3.jpg';
import { useLocation, useNavigate} from 'react-router-dom';
import BackButton from './BackButton';
import { FaHome } from 'react-icons/fa';


// Styled components
const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  h2{ color:white;
  }
  margin: 0 auto;
  overflow: hidden;

  @media (max-width: 768px) {
    /* Additional styles for tablet devices if needed */
  }

  @media (max-width: 480px) {
    /* Additional styles for mobile devices if needed */
  }
`;

const SliderImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  max-height: 700px; /* Maximum height */
  transition: opacity 0.5s ease-in-out;

  @media (max-width: 768px) {
    max-height: 400px; /* Smaller max height on tablet devices */
  }

  @media (max-width: 480px) {
    max-height: 300px; /* Even smaller max height on mobile devices */
  }
`;

const OverlayContent = styled.div`
  position: absolute;
  top: 70%;
  left: 63%;
  color: white;
  padding: 20px;
  width: 700px;
  border-radius: 10px;
  text-align: left;
  box-sizing: border-box;
  transform: translate(-50%, -50%); /* Ensures centering horizontally and vertically */

  /* For tablets and medium-sized screens */
  @media (max-width: 1024px) {
    top: 70%;
     left: 77%;
    width: 90%;
    font-size: 24px;
    padding: 15px;
  }

  /* For screens smaller than 768px (tablets) */
  @media (max-width: 768px) {
    left: 77%;
    width: 90%;
    font-size: 25px;
    padding: 12px;
  }

  /* For screens smaller than 480px (mobile phones) */
  @media (max-width: 480px) {
    top: 70%;
    left: 77%;
    width: 90%;
    font-size: 10px;
    padding: 10px;
    .home-icon{
    font-size:20px
    }
    .hehe
    {
    font-size:10px
    }
  }
`;

const OverlayContent1 = styled.div`
  position: absolute;
  top: 50%;
  left: 41%;
  font-size: 100px;
  color: white;
  padding: 20px;
  width: 700px;
  border-radius: 10px;
  text-align: left;
  box-sizing: border-box;
  transform: translateY(-50%); /* Center vertically */
  h2
  {
  font-size:100px;
  }

  /* For tablets and smaller screens */
  @media (max-width: 1024px) {
   top: 60%;
    left: 30%;
    width: 90%;
    padding: 10px;
    h2{
    font-size:60px
    }
  }

  /* For screens smaller than 768px (tablets) */
  @media (max-width: 768px) {
   top: 60%;
    left: 30%;
    width: 90%;
    padding: 10px;
    h2{
    font-size:60px
    }
  }

  /* For screens smaller than 480px (mobile phones) */
  @media (max-width: 480px) {
    top: 60%;
    left: 30%;
    width: 90%;
    padding: 10px;
    h2{
    font-size:30px
    }
  }


`;


const Carousel = () => {
  const location=useLocation()
  var variable=location.pathname
  const nav=useNavigate()
  const [op,setOp]=useState(true)

  const [product, setProduct] = useState(""); // Declare product as state

  useEffect(() => {
    const variable = location.pathname;
    if (variable === "/") {
      setProduct(""); // Set a value for product
    } else if (variable === "/About") {
      setProduct("ABOUT  ");
    }else if (variable === "/Products") {
      setProduct("PRODUCTS ");
    }else if (variable === "/Projects") {
      setProduct("PROJECTS");
    }
  }, []); 
  
  // Define the images to be displayed
  const images = [image1, image2, image3];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isSmallScreen, setIsSmallScreen] = React.useState(window.innerWidth < 480);

React.useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 480);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
}, []);

  useEffect(() => {
    const interval = setInterval(() => {
      // Change the image every 5 seconds
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change the time interval (in milliseconds) as needed

    return () => clearInterval(interval); // Clear the interval on component unmount
  }, [images.length]);

  return (
    <div>
    <SliderContainer>
      <SliderImage style={{ width: '100%', height: '800px' }}
        src={images[currentImageIndex]}
        alt={`Slide ${currentImageIndex + 1}`}
      />
      <OverlayContent1>
      <h2 >
        {product}
      </h2>
          
        
      </OverlayContent1>
      <OverlayContent>
        
        <div className='overlayelement' style={{display:"flex"}}>
          <div>< FaHome className='home-icon' style={{ fontSize: isSmallScreen ? '20px' : '40px' }} onClick={()=>nav("/")}/></div>
          <div ><BackButton className='hehe' /></div>
        </div>
      </OverlayContent>
    </SliderContainer>
    <div>

    </div>
    
    </div>
  );
};

export default Carousel;
